<template>
    <CModal
        :model-value="true"
        :hide-closer="hideCloser || preventBackdropClick"
        :title="title"
        @update:model-value="closeModal"
    >
        <slot />
        <template #footer>
            <slot name="footer" />
        </template>
    </CModal>
</template>

<script setup lang="ts">
const props = defineProps({
    title: {
        type: String,
        default: ''
    },
    hideCloser: {
        type: Boolean,
        default: false
    },
    preventBackdropClick: {
        type: Boolean,
        default: false
    },
    width: {
        type: [String, Number],
        default: undefined
    }
})

const emit = defineEmits(['close', 'before-close'])

function closeModal(value: boolean) {
    if (!value) {
        emit('close')
    }
}
</script>